import 'react-loading-skeleton/dist/skeleton.css';

import Skeleton from 'react-loading-skeleton';

import styles from './styles.module.scss';

export function SectionCatalogWithSearchSkeleton() {
  const skeletonCount = 4;
  return Array.from({ length: skeletonCount }).map((_, index) => (
    <div className={styles.skeleton} key={index}>
      <Skeleton width={40} height={40} borderRadius={0} />
      <Skeleton height={40} width={'100%'} borderRadius={0} />
    </div>
  ));
}
